import React, { useState } from 'react';
import {
  CheckCircle2,
  XCircle,
  RefreshCw,
  Cpu,
  ChevronDown,
  ChevronUp,
  FileCode,
  Settings,
  BarChart2,
  ShieldCheck,
  AlertTriangle,
  Info,
  CheckSquare,
  Zap,
  AlertCircle,
  Layers
} from 'lucide-react';

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ReviewGate
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ReviewGate = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    if (rejectReason.trim()) {
      onReject(rejectReason);
      setShowRejectModal(false);
      setRejectReason('');
    }
  };

  if (execution.status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle2 className="w-5 h-5" />
          <span className="font-medium">Execution approvata</span>
        </div>
      </div>
    );
  }

  if (execution.status === 'rejected') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-red-700">
          <XCircle className="w-5 h-5" />
          <span className="font-medium">Execution rigettata</span>
        </div>
        {execution.rejectionReason && (
          <p className="text-sm text-red-600 mt-2">{execution.rejectionReason}</p>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h3 className="font-medium text-gray-800 mb-3">Revisiona Output</h3>
        <div className="flex gap-3">
          <button onClick={() => onApprove()} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50">
            <CheckCircle2 className="w-4 h-4" /> Approva
          </button>
          <button onClick={onRegenerate} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
            <RefreshCw className="w-4 h-4" /> Rigenera
          </button>
          <button onClick={() => setShowRejectModal(true)} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
            <XCircle className="w-4 h-4" /> Rigetta
          </button>
        </div>
      </div>

      {showRejectModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 max-w-md w-full mx-4">
            <h3 className="font-semibold text-gray-800 mb-3">Motivo rigetto</h3>
            <textarea
              value={rejectReason}
              onChange={e => setRejectReason(e.target.value)}
              placeholder="Descrivi il problema con questa execution..."
              className="w-full border border-gray-300 rounded-lg p-3 text-sm resize-none h-32 focus:ring-2 focus:ring-red-300 focus:outline-none"
            />
            <div className="flex gap-3 mt-4">
              <button onClick={handleReject} disabled={!rejectReason.trim()}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
                Conferma Rigetto
              </button>
              <button onClick={() => setShowRejectModal(false)}
                className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors">
                Annulla
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// RendererHeader â€” banner con info renderer
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const RENDERER_COLORS = {
  veo:        { from: 'from-blue-600',    to: 'to-cyan-600' },
  kling:      { from: 'from-orange-500',  to: 'to-red-600' },
  runway:     { from: 'from-purple-600',  to: 'to-pink-600' },
  seedance:   { from: 'from-green-600',   to: 'to-teal-600' },
  higgsfield: { from: 'from-indigo-600',  to: 'to-violet-700' },
  hailuo:     { from: 'from-sky-600',     to: 'to-blue-700' },
};

const RendererHeader = ({ output, inputData }) => {
  const renderer = inputData?.targetRenderer || {};
  const rendererName = (renderer.name || 'unknown').toUpperCase();
  const rendererVersion = renderer.version || 'â€”';
  const colors = RENDERER_COLORS[renderer.name?.toLowerCase()] || { from: 'from-gray-600', to: 'to-gray-700' };

  const tv = output?.translation_validation || {};
  const ready = tv.execution_readiness ?? tv.translation_success ?? null;
  const semScore = tv.semantic_preservation_score ?? tv.semantic_score ?? null;
  const structScore = tv.structural_preservation_score ?? tv.structural_score ?? null;

  return (
    <div className={`bg-gradient-to-r ${colors.from} ${colors.to} rounded-xl p-5 text-white`}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <Cpu className="w-5 h-5 opacity-80" />
            <span className="text-sm font-medium opacity-80 uppercase tracking-wide">Backend Adapter</span>
          </div>
          <h2 className="text-xl font-bold">{rendererName} Adapter</h2>
          <p className="text-sm opacity-75 mt-1">Render IR â†’ {rendererName} v{rendererVersion} payload</p>
        </div>
        {ready !== null && (
          <div className={`shrink-0 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-bold ${ready ? 'bg-green-400/30 text-white' : 'bg-red-400/30 text-white'}`}>
            {ready ? <CheckCircle2 className="w-4 h-4" /> : <AlertCircle className="w-4 h-4" />}
            {ready ? 'READY' : 'NOT READY'}
          </div>
        )}
      </div>
      <div className="grid grid-cols-3 gap-3 mt-4 text-sm">
        <div className="bg-white/10 rounded-lg p-2">
          <div className="opacity-70 text-xs mb-0.5">Renderer</div>
          <div className="font-semibold">{rendererName}</div>
        </div>
        <div className="bg-white/10 rounded-lg p-2">
          <div className="opacity-70 text-xs mb-0.5">Version</div>
          <div className="font-semibold">{rendererVersion}</div>
        </div>
        <div className="bg-white/10 rounded-lg p-2">
          <div className="opacity-70 text-xs mb-0.5">Sem. Score</div>
          <div className="font-semibold">
            {semScore !== null ? (typeof semScore === 'number' && semScore <= 1 ? `${Math.round(semScore * 100)}%` : semScore) : 'â€”'}
          </div>
        </div>
      </div>
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// CollapsibleJsonCard â€” card collassabile generica
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const CollapsibleJsonCard = ({ title, icon: Icon, iconColor, borderColor, bgColor, data, defaultOpen = false, badge = null }) => {
  const [open, setOpen] = useState(defaultOpen);
  const isEmpty = !data || (typeof data === 'object' && Object.keys(data).length === 0);

  return (
    <div className={`border ${borderColor} rounded-xl overflow-hidden`}>
      <button
        onClick={() => setOpen(o => !o)}
        className={`w-full flex items-center justify-between px-4 py-3 ${bgColor} hover:opacity-90 transition-opacity`}
      >
        <div className="flex items-center gap-2">
          <Icon className={`w-4 h-4 ${iconColor}`} />
          <span className={`font-semibold text-sm ${iconColor}`}>{title}</span>
          {badge && <span className="text-xs opacity-60 ml-1">{badge}</span>}
          {isEmpty && <span className="text-xs opacity-50 italic">(empty)</span>}
        </div>
        {open ? <ChevronUp className={`w-4 h-4 ${iconColor} opacity-50`} /> : <ChevronDown className={`w-4 h-4 ${iconColor} opacity-50`} />}
      </button>
      {open && (
        <div className="bg-gray-950 p-4 overflow-x-auto">
          <pre className="text-xs text-green-300 font-mono whitespace-pre-wrap break-all leading-relaxed">
            {JSON.stringify(data, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// CapabilityReportCard â€” report leggibile
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const CapabilityReportCard = ({ report }) => {
  const r = report || {};
  const native = r.native_features || [];
  const approximated = r.approximated_features || [];
  const unsupported = r.unsupported_features || [];
  const limitations = r.renderer_limitations || r.approximation_rules || [];

  const formatList = (arr) =>
    Array.isArray(arr)
      ? arr.map(item => (typeof item === 'object' && item !== null ? JSON.stringify(item) : String(item)))
      : (typeof arr === 'object' && arr !== null ? Object.entries(arr).map(([k, v]) => `${k}: ${v}`) : [String(arr)]);

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5">
      <div className="flex items-center gap-2 mb-4">
        <BarChart2 className="w-5 h-5 text-indigo-500" />
        <h3 className="font-semibold text-gray-800">Capability Report</h3>
        <div className="ml-auto flex gap-2">
          {native.length > 0 && <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">{native.length} native</span>}
          {approximated.length > 0 && <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">{approximated.length} approx</span>}
          {unsupported.length > 0 && <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded-full">{unsupported.length} unsupported</span>}
        </div>
      </div>

      {/* Tutte le sezioni del report */}
      {Object.keys(r).length === 0 ? (
        <p className="text-sm text-gray-400 italic">No capability data available</p>
      ) : (
        <div className="space-y-3">
          {native.length > 0 && (
            <div>
              <div className="text-xs font-medium text-green-700 uppercase mb-1 flex items-center gap-1">
                <CheckSquare className="w-3.5 h-3.5" /> Native Features
              </div>
              <ul className="space-y-0.5">
                {formatList(native).map((f, i) => (
                  <li key={i} className="text-sm text-gray-700 flex items-start gap-1.5">
                    <span className="text-green-500 mt-0.5">âœ“</span> {f}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {approximated.length > 0 && (
            <div>
              <div className="text-xs font-medium text-amber-700 uppercase mb-1 flex items-center gap-1">
                <AlertTriangle className="w-3.5 h-3.5" /> Approximated Features
              </div>
              <ul className="space-y-0.5">
                {formatList(approximated).map((f, i) => (
                  <li key={i} className="text-sm text-gray-700 flex items-start gap-1.5">
                    <span className="text-amber-500 mt-0.5">â‰ˆ</span> {f}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {unsupported.length > 0 && (
            <div>
              <div className="text-xs font-medium text-red-700 uppercase mb-1 flex items-center gap-1">
                <XCircle className="w-3.5 h-3.5" /> Unsupported Features
              </div>
              <ul className="space-y-0.5">
                {formatList(unsupported).map((f, i) => (
                  <li key={i} className="text-sm text-gray-700 flex items-start gap-1.5">
                    <span className="text-red-500 mt-0.5">âœ—</span> {f}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {limitations.length > 0 && (
            <div>
              <div className="text-xs font-medium text-gray-600 uppercase mb-1 flex items-center gap-1">
                <Info className="w-3.5 h-3.5" /> Renderer Limitations
              </div>
              <ul className="space-y-0.5">
                {formatList(limitations).map((f, i) => (
                  <li key={i} className="text-sm text-gray-600">â€¢ {f}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Sezioni extra del report non enumerate sopra */}
          {Object.entries(r)
            .filter(([k]) => !['native_features', 'approximated_features', 'unsupported_features', 'renderer_limitations', 'approximation_rules'].includes(k))
            .map(([k, v]) => (
              <div key={k} className="border-t border-gray-100 pt-2 mt-2">
                <div className="text-xs text-gray-500 font-medium uppercase mb-1">{k.replace(/_/g, ' ')}</div>
                {typeof v === 'object'
                  ? <pre className="text-xs text-gray-700 bg-gray-50 rounded p-2 overflow-x-auto">{JSON.stringify(v, null, 2)}</pre>
                  : <p className="text-sm text-gray-700">{String(v)}</p>
                }
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// TranslationValidationCard
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const TranslationValidationCard = ({ validation }) => {
  const v = validation || {};
  const success = v.translation_success ?? v.execution_readiness ?? null;
  const unsupported = v.unsupported_components || [];
  const approximated = v.approximated_components || [];

  const scalarEntries = Object.entries(v).filter(([, val]) => typeof val !== 'object' || val === null);
  const arrayEntries = Object.entries(v).filter(([, val]) => Array.isArray(val) && val.length > 0);
  const objectEntries = Object.entries(v).filter(([, val]) => val !== null && typeof val === 'object' && !Array.isArray(val));

  const statusBg = success === true ? 'bg-green-50 border-green-200' : success === false ? 'bg-red-50 border-red-200' : 'bg-gray-50 border-gray-200';
  const StatusIcon = success === true ? ShieldCheck : success === false ? AlertTriangle : Info;
  const statusIconColor = success === true ? 'text-green-600' : success === false ? 'text-red-600' : 'text-gray-500';

  return (
    <div className={`border rounded-xl p-5 ${statusBg}`}>
      <div className="flex items-center gap-2 mb-4">
        <StatusIcon className={`w-5 h-5 ${statusIconColor}`} />
        <h3 className="font-semibold text-gray-800">Translation Validation</h3>
        {success !== null && (
          <span className={`ml-auto text-xs font-bold px-2 py-0.5 rounded-full ${success ? 'bg-green-600 text-white' : 'bg-red-600 text-white'}`}>
            {success ? 'PASSED' : 'FAILED'}
          </span>
        )}
      </div>

      {scalarEntries.length > 0 && (
        <dl className="grid grid-cols-2 gap-x-6 gap-y-2 mb-3">
          {scalarEntries.map(([k, val]) => (
            <div key={k}>
              <dt className="text-xs text-gray-400 capitalize">{k.replace(/_/g, ' ')}</dt>
              <dd className={`text-sm font-medium ${val === true ? 'text-green-700' : val === false ? 'text-red-700' : 'text-gray-800'}`}>
                {String(val)}
              </dd>
            </div>
          ))}
        </dl>
      )}

      {arrayEntries.map(([k, arr]) => (
        <div key={k} className="mb-2">
          <div className="text-xs text-gray-500 font-medium uppercase mb-1">{k.replace(/_/g, ' ')}</div>
          <ul className="space-y-0.5">
            {arr.map((item, i) => (
              <li key={i} className="text-sm text-gray-700">â€¢ {typeof item === 'object' ? JSON.stringify(item) : item}</li>
            ))}
          </ul>
        </div>
      ))}

      {objectEntries.map(([k, val]) => (
        <div key={k} className="border-t border-gray-100 pt-2 mt-2">
          <div className="text-xs text-gray-500 font-medium uppercase mb-1">{k.replace(/_/g, ' ')}</div>
          <pre className="text-xs text-gray-700 bg-white/60 rounded p-2 overflow-x-auto">{JSON.stringify(val, null, 2)}</pre>
        </div>
      ))}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Contract163View â€” main component
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const Contract163View = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  if (!execution?.outputData) {
    return (
      <div className="h-full flex items-center justify-center text-gray-400">
        <div className="text-center">
          <Layers className="w-12 h-12 mx-auto mb-3 opacity-30" />
          <p>Nessun output disponibile</p>
        </div>
      </div>
    );
  }

  const { backend_payload, backend_prompt, backend_parameters, capability_report, translation_validation } = execution.outputData;
  const inputData = execution.inputData || execution.input || {};

  return (
    <div className="h-full overflow-y-auto">
      <div className="space-y-4 max-w-4xl mx-auto p-6">

        {/* Header */}
        <RendererHeader output={execution.outputData} inputData={inputData} />

        {/* Backend Payload */}
        <CollapsibleJsonCard
          title="Backend Payload"
          icon={Zap}
          iconColor="text-blue-600"
          borderColor="border-blue-200"
          bgColor="bg-blue-50"
          data={backend_payload}
          defaultOpen={true}
          badge={`${JSON.stringify(backend_payload || {}).length} chars`}
        />

        {/* Backend Prompt */}
        <CollapsibleJsonCard
          title="Backend Prompt"
          icon={FileCode}
          iconColor="text-purple-600"
          borderColor="border-purple-200"
          bgColor="bg-purple-50"
          data={backend_prompt}
          defaultOpen={false}
        />

        {/* Backend Parameters */}
        <CollapsibleJsonCard
          title="Backend Parameters"
          icon={Settings}
          iconColor="text-teal-600"
          borderColor="border-teal-200"
          bgColor="bg-teal-50"
          data={backend_parameters}
          defaultOpen={false}
        />

        {/* Capability Report */}
        {capability_report && (
          <CapabilityReportCard report={capability_report} />
        )}

        {/* Translation Validation */}
        {translation_validation && (
          <TranslationValidationCard validation={translation_validation} />
        )}

        {/* ReviewGate */}
        <ReviewGate
          execution={execution}
          onApprove={onApprove}
          onReject={onReject}
          onRegenerate={onRegenerate}
          loading={loading}
        />

      </div>
    </div>
  );
};

export default Contract163View;
